import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["images", "children"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import BaseImage from '../../../../../../atoms/Image';
import { ImagePropType } from '../../../../../../services/proptypes';
import { BaseCarouselPropTypes, BaseCarouselDefaultProps } from '../../../../../foundation/components/Carousel/types/base';
import BasicCarousel from '../../../../../foundation/components/Carousel/variants/BasicCarousel';
import { ChildrenPropType } from '../../../../../foundation/types/component';
import './ImageCarousel.css';
var defaultProps = _objectSpread(_objectSpread({}, BaseCarouselDefaultProps), {}, {
  children: null,
  autoScroll: false,
  continuous: true,
  displayPlayPauseButton: false
});
export default function ImageCarousel(_ref) {
  var images = _ref.images,
    children = _ref.children,
    carouselProps = _objectWithoutProperties(_ref, _excluded);
  if (_isEmpty(images) && _isEmpty(children)) {
    return null;
  }
  if (_isEmpty(images) && !_isEmpty(children)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "image-carousel-container no-images"
    }, children);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "image-carousel-container"
  }, /*#__PURE__*/React.createElement(BasicCarousel, _extends({}, carouselProps, {
    size: 1,
    items: images.map(function (image) {
      return /*#__PURE__*/React.createElement(BaseImage, {
        key: JSON.stringify(image),
        src: image,
        background: true
      }, children);
    })
  })));
}
ImageCarousel.defaultProps = defaultProps;